import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertCircle, BookX, BrainCircuit } from 'lucide-react';
export function Problem() {
  return <section className="py-24 bg-white" data-id="element-158">
      <div className="max-w-4xl mx-auto px-6 lg:px-8" data-id="element-159">
        <FadeIn data-id="element-160">
          <div className="text-center mb-16" data-id="element-161">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-162">
              El problema no es que seas un "mal padre" o que tu hijo sea
              "manipulador".
            </h2>
            <p className="text-xl text-charcoal-light" data-id="element-163">
              El problema es que los libros de crianza de 300 páginas no sirven
              cuando estás en medio del caos.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-8" data-id="element-164">
          <FadeIn delay={0.1} data-id="element-165">
            <div className="flex gap-6 p-6 rounded-2xl bg-cream-dark/50" data-id="element-166">
              <div className="flex-shrink-0" data-id="element-167">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-sage-500" data-id="element-168">
                  <BrainCircuit size={24} data-id="element-169" />
                </div>
              </div>
              <div data-id="element-170">
                <h3 className="text-xl font-semibold mb-2" data-id="element-171">
                  Intentas razonar...
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-172">
                  Y su cerebro lógico está apagado. Las palabras no entran, solo
                  rebotan contra su frustración.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-173">
            <div className="flex gap-6 p-6 rounded-2xl bg-cream-dark/50" data-id="element-174">
              <div className="flex-shrink-0" data-id="element-175">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-terracotta" data-id="element-176">
                  <AlertCircle size={24} data-id="element-177" />
                </div>
              </div>
              <div data-id="element-178">
                <h3 className="text-xl font-semibold mb-2" data-id="element-179">
                  Intentas castigar...
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-180">
                  Y la angustia aumenta. El llanto se vuelve más desesperado y
                  la desconexión entre ustedes crece.
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-181">
            <div className="flex gap-6 p-6 rounded-2xl bg-cream-dark/50" data-id="element-182">
              <div className="flex-shrink-0" data-id="element-183">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-sm text-sage-600" data-id="element-184">
                  <BookX size={24} data-id="element-185" />
                </div>
              </div>
              <div data-id="element-186">
                <h3 className="text-xl font-semibold mb-2" data-id="element-187">
                  Intentas ceder...
                </h3>
                <p className="text-charcoal-light leading-relaxed" data-id="element-188">
                  Y solo estás "entrenando" a su cerebro para que grite más
                  fuerte la próxima vez. Estás agotada, te sientes observada y
                  temes el próximo berrinche antes de que ocurra.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}